import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ProtocolCategory, ProtocolStatus } from '../../../types';
import { setFilters } from '../../../redux/slices/protocolSlice';

const Filter = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector(state => state.protocols);

  const categories: { value: ProtocolCategory | ''; label: string }[] = [
    { value: '', label: 'Todas las categorías' },
    { value: 'medical', label: 'Médicos' },
    { value: 'surgical', label: 'Quirúrgicos' },
    { value: 'cardiac', label: 'Cardíacos' },
    { value: 'emergency', label: 'Emergencias' },
    { value: 'pediatric', label: 'Pediatría' },
    { value: 'geriatric', label: 'Geriatría' },
  ];

  const statusOptions: { value: ProtocolStatus | ''; label: string }[] = [
    { value: '', label: 'Todos los estados' },
    { value: 'active', label: 'Activo' },
    { value: 'draft', label: 'Borrador' },
    { value: 'archived', label: 'Archivado' },
    { value: 'deprecated', label: 'Deprecado' },
  ];

  const sortOptions = [
    { value: 'title', label: 'Título' },
    { value: 'createdAt', label: 'Fecha de Creación' },
    { value: 'updatedAt', label: 'Última Actualización' },
    { value: 'viewCount', label: 'Vistas' },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      <FormControl size='small' sx={{ minWidth: 180 }}>
        <Select
          value={filters.category || ''}
          onChange={e => dispatch(setFilters({ category: e.target.value || '' }))}
          displayEmpty
        >
          {categories.map(cat => (
            <MenuItem key={cat.value} value={cat.value}>
              {cat.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size='small' sx={{ minWidth: 180 }}>
        <Select
          value={filters.status || ''}
          onChange={e => dispatch(setFilters({ status: e.target.value || '' }))}
          displayEmpty
        >
          {statusOptions.map(status => (
            <MenuItem key={status.value} value={status.value}>
              {status.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size='small' sx={{ minWidth: 180 }}>
        <Select
          value={`${filters.sortBy}-${filters.sortOrder}`}
          onChange={e => {
            const [sortBy, sortOrder] = e.target.value.split('-');
            dispatch(
              setFilters({
                sortBy,
                sortOrder: sortOrder as 'asc' | 'desc',
              })
            );
          }}
        >
          {sortOptions.map(option => (
            <Box key={option.value}>
              <MenuItem value={`${option.value}-asc`}>{option.label} (A-Z)</MenuItem>
              <MenuItem value={`${option.value}-desc`}>{option.label} (Z-A)</MenuItem>
            </Box>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Filter;
